/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
var languageKey;
var cnItems = [{
    icon: 'icon-zhuce',
    text: '注册账号',
    desc: '您需要拨打400电话<br>与客服沟通后为您开通企业账户<br>ASC现有客户请直接与专属销售联系'
}, {
    icon: 'icon-shenhe',
    text: '信息审核',
    desc: '完善公司相关信息等待审核<br>审核通过后可正常下单'
}, {
    icon: 'icon-cart',
    text: '购买下单',
    desc: '您在购买时<br>可通过询价获得优惠价'
}, {
    icon: 'icon-wuliu',
    text: '物流配送',
    desc: '支付订单即自动发货<br>也可以查询快递信息'
}];
var enItems = [{
    icon: 'icon-zhuce',
    text: 'Register Account',
    desc: 'You need to dial 4008832299 to open an enterprise for you after communicating with customer service.Existing Customers Please contact exclusive salesperson directly.'
}, {
    icon: 'icon-shenhe',
    text: 'Message Validate',
    desc: 'After the company information audit is passed, you can create the order and buy the commodity.'
}, {
    icon: 'icon-cart',
    text: 'Purchase Order',
    desc: 'you can get a preferential price through inquiry when you purchase.'
}, {
    icon: 'icon-wuliu',
    text: 'Logistics Distribution',
    desc: 'After you pay the order, we will send out goods immediately and you can queried the delivery information.'
}];
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        list: nb.model.List
    },
    method: {
        init: function () {
            var list = this.get('list');
            list.set('itemType', require('../../view/register/Item'));
            nb.model.onChange('changeLanguageReady', function (inEvent, inData) {
                languageKey = inData;
                if(inData == 'cn'){
                    list.set('items', cnItems);
                }else{
                    list.set('items', enItems);
                }
            }, this);

        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/register/Register.js
// module id = 533
// module chunks = 6